import { render, staticRenderFns } from "./ProtocolMessage.vue?vue&type=template&id=704dfcdf&scoped=true"
import script from "./ProtocolMessage.vue?vue&type=script&lang=js"
export * from "./ProtocolMessage.vue?vue&type=script&lang=js"
import style0 from "./ProtocolMessage.vue?vue&type=style&index=0&id=704dfcdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704dfcdf",
  null
  
)

export default component.exports